const PREFIXE_SESSION = 'boutiqueclub:payplug-test:';
const uuid = (valeur) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(valeur || ''));

export const payplugTestFrontendActif = (env = process.env) => env?.REACT_APP_PAYPLUG_TEST_ENABLED === 'true';

export async function empreintePayplugTest(valeur, cryptoApi = window.crypto) {
  if (!cryptoApi?.subtle) throw new Error('PAYPLUG_TEST_CRYPTO_INDISPONIBLE');
  const digest = await cryptoApi.subtle.digest('SHA-256', new TextEncoder().encode(String(valeur || '')));
  return Array.from(new Uint8Array(digest), (octet) => octet.toString(16).padStart(2, '0')).join('');
}

export function enregistrerReprisePayplugTest(storage, intentionId, donnees = {}) {
  if (!storage || !uuid(intentionId) || !Array.isArray(donnees.panier) || !donnees.campagne_id) return false;
  storage.setItem(`${PREFIXE_SESSION}${intentionId}`, JSON.stringify({
    intention_id:intentionId,
    campagne_id:String(donnees.campagne_id),
    groupe_slug:String(donnees.groupe_slug || '').toLowerCase(),
    retour_url:String(donnees.retour_url || '/'),
    panier:donnees.panier,
    cree_at:new Date().toISOString(),
  }));
  return true;
}

export function lireReprisePayplugTest(storage, intentionId) {
  if (!storage || !uuid(intentionId)) return null;
  try {
    const valeur = JSON.parse(storage.getItem(`${PREFIXE_SESSION}${intentionId}`) || 'null');
    return valeur?.intention_id === intentionId && Array.isArray(valeur?.panier) ? valeur : null;
  } catch { return null; }
}

export function retrouverPanierPayplugTest(storage, campagneId, groupeSlug = '') {
  if (!storage || !campagneId) return null;
  for (let index = storage.length - 1; index >= 0; index -= 1) {
    const cle = storage.key(index);
    if (!cle?.startsWith(PREFIXE_SESSION)) continue;
    const valeur = lireReprisePayplugTest(storage, cle.slice(PREFIXE_SESSION.length));
    if (valeur?.campagne_id === String(campagneId)
        && (!groupeSlug || valeur.groupe_slug === String(groupeSlug).toLowerCase())) return valeur;
  }
  return null;
}

export function terminerReprisePayplugTest(storage, intentionId) {
  if (storage && uuid(intentionId)) storage.removeItem(`${PREFIXE_SESSION}${intentionId}`);
}

export const presentationStatutPayplugTest = (statut) => {
  const valeur = String(statut || '').toUpperCase();
  if (valeur === 'PAIEMENT_CONFIRME') return { type:'CONFIRME', titre:'Paiement confirmé', detail:'Votre commande a été confirmée par le serveur après vérification PayPlug.' };
  if (valeur === 'REFUSE') return { type:'REFUSE', titre:'Paiement refusé', detail:'Aucune confirmation de commande n’a été enregistrée. Votre panier peut être repris.' };
  if (['ABANDONNE','EXPIRE','ERREUR'].includes(valeur)) return { type:'NON_CONFIRME', titre:'Paiement non confirmé', detail:'Le paiement n’a pas été confirmé. Votre panier peut être repris.' };
  return { type:'VERIFICATION', titre:'Paiement en cours de vérification', detail:'La confirmation serveur est en attente. Actualisez dans quelques instants.' };
};
